import { render, staticRenderFns } from "./UserAccountWidget.vue?vue&type=template&id=0cf116dc&scoped=true&"
import script from "./UserAccountWidget.vue?vue&type=script&lang=ts&"
export * from "./UserAccountWidget.vue?vue&type=script&lang=ts&"
import style0 from "./UserAccountWidget.vue?vue&type=style&index=0&id=0cf116dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf116dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf116dc')) {
      api.createRecord('0cf116dc', component.options)
    } else {
      api.reload('0cf116dc', component.options)
    }
    module.hot.accept("./UserAccountWidget.vue?vue&type=template&id=0cf116dc&scoped=true&", function () {
      api.rerender('0cf116dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/UserAccountWidget.vue"
export default component.exports